module.exports = __webpack_public_path__ + "static/media/taskmanager_logo.cf1725e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/taskmanager_logo.png
// module id = 834
// module chunks = 0